import React from 'react';
import CollegeCard from './CollegeCard';
import AddMoreCard from './AddMoreCard';
import styles from './TopChoices.module.css';

const TopChoices = ({ colleges, onCollegeSelect, onRemoveCollege }) => (
  <div className={styles.container}>
    <div className={styles.title}>Your Top Choices</div>
    <div className={styles.grid}>
      {colleges && colleges.length > 0 ? (
        <>
          {colleges.map((college, idx) => (
            <CollegeCard 
              key={idx} 
              college={college}
              onClick={() => onCollegeSelect && onCollegeSelect(college)}
              onRemove={() => onRemoveCollege && onRemoveCollege(college)}
            />
          ))}
          <AddMoreCard />
        </>
      ) : (
        <>
          <div className={styles.emptyState}>
            <p>You haven't added any colleges to your list yet.</p>
            <p>Start exploring to find your perfect match!</p>
          </div>
          <AddMoreCard />
        </>
      )}
    </div>
  </div>
);

export default TopChoices; 